import React, { useEffect, useState, useContext } from "react";
import Loading from "components/Loading";
import PropTypes from "prop-types";
import { StoreContext } from "components/StoreContext";

const PartnerDetailsCard = ({ partner }) => {
  const { StoreAPI } = useContext(StoreContext);
  const [loading, updateLoading] = useState(true);
  const [pageError, updatePageError] = useState(null);
  const [partnerContent, updatePartnerContent] = useState(null);

  useEffect(() => {
    StoreAPI.get(`partners/search?partnercode=${partner}`)
      .then(response => {
        updateLoading(false);
        updatePageError(false);
        updatePartnerContent(response.data);
      })
      .catch(error => {
        console.log(error);
        updateLoading(false);
      }, []);
  }, [StoreAPI, partner]);

  return (
    <>
      {loading && (
        <div className="loadingHolder">
          <Loading />
        </div>
      )}
      {pageError && <div>{pageError}</div>}
      {partnerContent && (
        <div className="partner__card">
          <div className="partner__card--header" />
          {partnerContent.image && (
            <div className="partner__card--image">
              <img
                className="partner__card--logo"
                src={partnerContent.image}
                alt={`${partnerContent.nameFull}_logo`}
              />
            </div>
          )}
          <h6 className="partner__card--name">{partnerContent.nameFull}</h6>
          {partnerContent.description && (
            <div
              className="partner__card--description"
              dangerouslySetInnerHTML={{
                __html: partnerContent.description
              }}
            />
          )}
          {partnerContent.nameSEO && (
            <div className="partner__card--action">
              <a href={`/partners/${partnerContent.nameSEO}`}>
                View All Courses
              </a>
            </div>
          )}
        </div>
      )}
    </>
  );
};

PartnerDetailsCard.propTypes = {
  partner: PropTypes.string
};

PartnerDetailsCard.defaultProps = {
  partner: null
};

export default PartnerDetailsCard;
